import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../../pages/pages-shared.module';
import {SimpleSelectPopoverComponent} from './simple-select-popover.component';
import {SimpleSelectComponent} from './simple-select.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        SimpleSelectComponent,
        SimpleSelectPopoverComponent
    ],
    entryComponents: [
        SimpleSelectPopoverComponent
    ],
    exports: [
        SimpleSelectComponent,
        SimpleSelectPopoverComponent
    ]
})
export class SimpleSelectModule {
}
